"use strict";
/* tslint:disable */
var load_themed_styles_1 = require('@microsoft/load-themed-styles');
load_themed_styles_1.loadStyles([{ "rawString": ".ms-DocumentCardTitle{padding:8px 16px;display:block;font-family:\"Segoe UI WestEuropean\",\"Segoe UI\",-apple-system,BlinkMacSystemFont,Roboto,\"Helvetica Neue\",sans-serif;-webkit-font-smoothing:antialiased;font-size:17px;font-weight:300;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";height:38px;line-height:21px;overflow:hidden;word-wrap:break-word}" }]);
/* tslint:enable */

//# sourceMappingURL=DocumentCardTitle.scss.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/DocumentCard/DocumentCardTitle.scss.js
 ** module id = 184
 ** module chunks = 0
 **/